var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.931,
    height: 11.273,
    viewBox: "318.534 31.363 11.931 11.273",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 1862"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 1201"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 1200",
    transform: "translate(318.534 31.363)",
    clipPath: "url(\"#a\")"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.476 11.273a.85.85 0 0 1-.603-.25l-4.51-4.51A1.232 1.232 0 0 1 0 5.637c0-.332.13-.643.363-.877L4.873.25A.853.853 0 0 1 6.08 1.456L1.9 5.636l4.18 4.181a.853.853 0 0 1-.604 1.456",
    fill: "rgba(111,111,111,0.87 )",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6562"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 1202"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 1200",
    transform: "translate(324.136 31.363)",
    clipPath: "url(\"#b\")"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.476 11.273a.85.85 0 0 1-.603-.25l-4.51-4.51A1.232 1.232 0 0 1 0 5.637c0-.332.13-.643.363-.877L4.873.25A.853.853 0 0 1 6.08 1.456L1.9 5.636l4.18 4.181a.853.853 0 0 1-.604 1.456",
    fill: "rgba(111,111,111,0.87 )",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6562"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h6.33v11.273H0V0z",
    "data-name": "Rectangle 1203"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h6.33v11.273H0V0z",
    "data-name": "Rectangle 1203"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrowLeft.f5306a84620edce02cabb302611260a8.svg";
export { ForwardRef as ReactComponent };